export default __webpack_public_path__ + "static/media/frequent.d60323f0.png";